import React from 'react';
import { Modal, Alert, Form, DatePicker } from 'antd';
import dayjs from 'dayjs';

const { RangePicker } = DatePicker;

interface JourneySyncModalProps {
  visible: boolean;
  onClose: () => void;
  onSync: () => void;
  t: (key: string) => string;
  loading: boolean;
  dateRange: [dayjs.Dayjs, dayjs.Dayjs];
  onDateRangeChange: (dates: [dayjs.Dayjs, dayjs.Dayjs]) => void;
  isMobile: boolean;
}

const JourneySyncModal: React.FC<JourneySyncModalProps> = ({
  visible,
  onClose,
  onSync,
  t,
  loading,
  dateRange,
  onDateRangeChange,
  isMobile
}) => {
  return (
    <Modal
      title={t('vcomsat.sync.journey')}
      open={visible}
      onCancel={onClose}
      onOk={onSync}
      confirmLoading={loading}
      okText={t('sync')}
      cancelText={t('cancel')}
      width={isMobile ? '95%' : 600}
      style={{ top: isMobile ? 20 : undefined }}
    >
      <Alert
        message={t('vcomsat.journey.sync.note')}
        description={t('vcomsat.journey.sync.description')}
        type="info"
        showIcon
        style={{ marginBottom: 16 }}
      />
      <Form layout="vertical">
        <Form.Item
          label={t('date.range')}
          required
        >
          <RangePicker
            value={dateRange}
            onChange={(dates) => {
              if (dates && dates[0] && dates[1]) {
                onDateRangeChange([dates[0], dates[1]]);
              }
            }}
            style={{ width: '100%' }}
            format="YYYY-MM-DD"
          />
        </Form.Item>
      </Form>
    </Modal>
  );
};

export default JourneySyncModal;
